const config = {
  // Production
  baseURL: "https://en-vivo-rf-api-x7gq7zmvhq-uc.a.run.app/api/v1",
  // Development
  //baseURL: "http://localhost:9000/api/v1",
};

export default config;
